import script from "./FaqsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FaqsPage.vue?vue&type=script&setup=true&lang=js"

import "./FaqsPage.vue?vue&type=style&index=0&id=67e6b7d9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67e6b7d9"]])

export default __exports__